"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;

var _utils = require("../../../../utils");

/**
 * @private
*/
var color = function (code) {
  if (code === void 0) {
    code = '';
  }

  code = code.toLowerCase().replace(/\s/, '-');

  switch (code) {
    case 'mini':
      return '#6fb314';

    case 'minor':
      return '#dfcb01';

    case 'light':
      return '#ce8f00';

    case 'moderate':
      return '#ff5d01';

    case 'strong':
      return '#e90004';

    case 'major':
      return '#ce0052';

    case 'great':
      return '#b90285';

    case 'catastrophic':
      return '#f500ff';

    default:
      return '#000000';
  }
};
/**
 * @private
*/


var size = function (code) {
  if (code === void 0) {
    code = '';
  }

  code = code.toLowerCase().replace(/\s/, '-');

  switch (code) {
    case 'minor':
      return 18;

    case 'light':
      return 20;

    case 'moderate':
      return 22;

    case 'strong':
      return 26;

    case 'major':
      return 30;

    case 'great':
      return 36;

    case 'catastrophic':
      return 42;

    default:
      return 16;
  }
};
/**
 * @private
*/


var config = {
  data: {
    request: {
      endpoint: 'earthquakes'
    },
    properties: {
      id: 'report.id',
      timestamp: 'report.timestamp'
    }
  },
  style: {
    marker: function (data) {
      var type = (0, _utils.get)(data, 'report.type');
      var magnitude = (0, _utils.get)(data, 'report.mag');

      if (magnitude >= 9) {
        type = 'catastrophic';
      }

      var width = size(type);
      return {
        className: 'marker-earthquake',
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: color(type)
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [width, width]
      };
    }
  },
  animation: {
    enabled: true
  }
};
exports.config = config;
var _default = config;
exports.default = _default;